module.exports = __webpack_public_path__ + "static/media/0036.4c50fb01.png";